/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import './HorizontalAddressDisplayView.css';
import tmplHorizontalAddressDisplayView from './HorizontalAddressDisplayView.hbs';

const HorizontalAddressDisplayView = View.extend({
  template: tmplHorizontalAddressDisplayView,

  templateContext() {
    const hasAddress =
      this.model.get('addressLine1') ||
      this.model.get('addressLine2') ||
      this.model.get('addressLine3') ||
      this.model.get('city');
    return {
      hasAddress,
      formattedAddress: this.formatAddress(),
      showCounty: this.options.showCounty
    };
  },

  formatAddress() {
    let formattedAddress = '';
    if (this.model.get('organization')) formattedAddress = formattedAddress.concat(this.model.get('organization'), ' ');
    if (this.model.get('base')) formattedAddress = formattedAddress.concat(this.model.get('base'), ' ');
    if (this.model.get('addressLine1')) formattedAddress = formattedAddress.concat(this.model.get('addressLine1'), ' ');
    if (this.model.get('addressLine2')) formattedAddress = formattedAddress.concat(this.model.get('addressLine2'), ' ');
    if (this.model.get('buildingFloorNumber'))
      formattedAddress = formattedAddress.concat(this.model.get('buildingFloorNumber'), ' ');
    if (this.model.get('floorNumber')) formattedAddress = formattedAddress.concat(this.model.get('floorNumber'), ' ');
    if (this.model.get('roomPoleNumber'))
      formattedAddress = formattedAddress.concat(this.model.get('roomPoleNumber'), ' ');
    if (this.model.get('city')) formattedAddress = formattedAddress.concat(this.model.get('city'), ' ');
    if (this.model.get('regionName')) formattedAddress = formattedAddress.concat(this.model.get('regionName'), ' ');
    if (this.model.get('zip')) formattedAddress = formattedAddress.concat(this.model.get('zip'));
    if (this.model.get('country') && this.model.get('country') !== 'US')
      formattedAddress = formattedAddress.concat(' ', this.model.get('country'));
    formattedAddress = formattedAddress.trim();
    return formattedAddress;
  },

  className() {
    const classesOption = this.options.classes;
    const classNameBase = 'address-display-view';
    return classesOption ? classNameBase : `${classNameBase} ${classesOption}`;
  }
});

export default HorizontalAddressDisplayView;
